module.exports = __webpack_public_path__ + "img/gaojing1.171ea6b6.png";